import React from 'react';
import { HiPlus } from 'react-icons/hi';

export const TransactionNotes = ({ transaction }) => {
  const notes = transaction?.notes || [];
  const finishedTransactionSummaryNote =
    transaction?.finishedTransactionSummary;

  // Merge summary as first note if exists
  const allNotes = finishedTransactionSummaryNote
    ? [
        {
          content: finishedTransactionSummaryNote,
          author: 'System',
          date: 'Final Summary',
        },
        ...notes,
      ]
    : notes;

  return (
    <div className="mt-6 bg-white/30 backdrop-blur-md border border-white/20 rounded-xl p-5 shadow-lg">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-semibold text-gray-100">
            Transaction Notes
          </h2>
          {allNotes.length > 0 && (
            <span className="text-xs bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded-full font-medium">
              {allNotes.length}
            </span>
          )}
        </div>

        <button className="flex items-center text-sm text-yellow-200 hover:underline">
          <HiPlus className="mr-1 w-4 h-4" />
          Add Note
        </button>
      </div>

      <div className="space-y-3">
        {allNotes.length === 0 ? (
          <p className="text-sm text-gray-300">No notes have been added yet.</p>
        ) : (
          allNotes.map((note, idx) => (
            <div
              key={idx}
              className={`px-4 py-2 rounded-2xl backdrop-blur-sm shadow-sm transition ${
                idx === 0 && finishedTransactionSummaryNote
                  ? 'bg-indigo-100/10 text-white'
                  : 'bg-white/40 hover:bg-white/50 text-gray-800'
              }`}
            >
              <p className="text-sm">{note.content}</p>
              <span className="text-xs text-white italic">
                {note.author ? `– ${note.author}` : ''} {note.date}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
